// Common routes
import Signup from "../Pages/Signup.jsx";
import ResetPassword from "../Pages/ResetPassword.jsx";
import ComingSoon from "./../Pages/ComingSoon";

//client routes
import AnalyticsPage from "../Pages/Dashboard/AnalyticsPage.jsx";
import PlatformDashboard from "../Pages/Platform/Dashboard/platformDash.jsx";
import CisoDashboard from "../Pages/Dashboard/CisoDashboard.jsx";
import InventoryAssest from "../Pages/Inventory/InventoryAssest.jsx";
import InventoryAWS from "../Pages/Inventory/InventoryAWS.jsx";
import InventoryGCP from "../Pages/Inventory/InventoryGCP.jsx";
import InventoryAzure from "../Pages/Inventory/InventoryAzure.jsx";
import CreateNewScan from "../Pages/SecurityHub/CreateNewScan.jsx";
import Scan from "../Pages/SecurityHub/Scan.jsx";
import ScanPolicy from "../Pages/SecurityHub/ScanPolicy.jsx";
import ScanReport from "../Pages/SecurityHub/ScanReport.jsx";
import ScanReportPage from "../Pages/SecurityHub/ScanReportPage.jsx";
import CreateNewIntegration from "../Pages/SecurityHub/CreateNewScan/CreateNewIntegration.jsx";
import ViewTrainings from "../Pages/Settings/ViewTrainings.jsx";
import Audit from "../Pages/Compliance/Audit.jsx";
import Evidence from "../Pages/Compliance/Evidence.jsx";
import EvidencePageCollection from "../Pages/Compliance/EvidencePageCollection.jsx";
import PeopleManagement from "../Pages/Compliance/PeopleManagement.jsx";
import PolicyManagement from "../Pages/Compliance/PolicyManagement.jsx";
import AuditEvidence from "../Pages/Compliance/AuditEvidence.jsx";
import ListOfNonCompliances from "../Pages/Compliance/ListOfNonCompliances.jsx";
import VendorManagement from "../Pages/Compliance/VendorManagement.jsx";
import Response from "../Pages/Compliance/Response.jsx";
import RiskManagement from "../Pages/Compliance/RiskManagement.jsx";
import VendorSendPage from "../Pages/Compliance/VendorSendPage.jsx";
import OrganizationInfo from "../Pages/Settings/OrganizationInfo.jsx";
import UserManagement from "../Pages/Settings/UserManagement.jsx";
import RolesPage from "../Pages/Settings/RolesManagment.jsx";
import TrainingManagement from "../Pages/Settings/TrainingManagement.jsx";
import ServiceRequests from "../Pages/ServiceRequest/ServiceRequests.jsx";
import ListOfException from "../Pages/ReviewsApproval/ListOfException.jsx";
import VendorReview from "../Pages/ReviewsApproval/VendorReview.jsx";
import ResponseReview from "../Pages/ReviewsApproval/ResponseReview.jsx";
import CreateNew from "../components/CreateNew.jsx";

//platform routres
import PlatformClient from "../Pages/Platform/clientManagement/PlatformClient.jsx";
import CreateNewClient from "../Pages/Platform/clientManagement/CreateNewClient.jsx";
import EditPlatformClient from "../Pages/Platform/clientManagement/EditPlatformClient.jsx";
import PlatformUserManagement from "../Pages/Platform/user/PlatformUserManagement.jsx";
import RoleManagment from "../Pages/Platform/settings/RoleManagement.jsx";
import Program from "../Pages/Platform/platformCompliance/Program.jsx";

//Loader screen
import NotificationSkeletonLoading from "../components/Notification/NotificationSkeletonLoading.jsx";
import Technology from "../Pages/Technology/MainPage.jsx";
import InventoryAWSPage from "../Pages/Technology/Aws.jsx";
import InventoryAzurePage from "../Pages/Technology/Azure.jsx";
import InventoryGCPPage from "../Pages/Technology/GCP.jsx";
import ComputeAwsApplicationData from "../Pages/Technology/ComputeAwsApplicationData.jsx";
import Application from "../Pages/Technology/Application.jsx";
import ApplicationData from "../Pages/Technology/ApplicationData.jsx";

export const commonRoutes = [
  { path: "/forgetpassword", element: Signup },
  { path: "/auth/reset-password", element: ResetPassword },
  {
    path: "/coming-soon",
    element: ComingSoon,
  },
];

export const platformRoutes = [
  {
    path: "/dashboard",
    element: PlatformDashboard,
    requiredPermission: "clientList",
  },
  {
    path: "/client-management",
    element: PlatformClient,
    requiredPermission: "clientList",
  },
  {
    path: "/client-management/createNewClient",
    element: CreateNewClient,
    requiredPermission: "clientList",
  },
  {
    path: "/client-management/editClient/:clientId",
    element: EditPlatformClient,
    requiredPermission: "clientList",
  },
  {
    path: "/user-management",
    element: PlatformUserManagement,
    requiredPermission: "userList",
  },
  {
    path: "/role-management",
    element: RoleManagment,
    requiredPermission: "roleList",
  },
  {
    path: "/complianceProgram",
    element: Program,
    requiredPermission: "programList",
  },
];

export const clientRoutes = [
  {
    path: "/analytics-dashboard",
    element: AnalyticsPage,
    requiredPermission: "secDash",
  },
  {
    path: "/ciso-dashboard",
    element: CisoDashboard,
    requiredPermission: "cisoDash",
  },
  {
    path: "/notification",
    element: Notification,
    fallback: NotificationSkeletonLoading,
    requiredPermission: "notificationList",
  },
  {
    path: "/inventory/assets",
    element: InventoryAssest,
    requiredPermission: "inventoryAssestList",
  },
  // Reviews
  {
    path: "/technology/aws/compute",
    element: ComputeAwsApplicationData,
    requiredPermission: "inventoryAWSList",
  },

  {
    path: "/technology/aws/:service",
    element: ApplicationData,
    requiredPermission: "inventoryAWSList",
  },
  // {
  //   path: "/technology/:service",
  //   element: ApplicationData,
  //   requiredPermission: "inventoryAWSList",
  // },
  // {
  //   path: "/technology/:application",
  //   element: Application,
  //   requiredPermission: "inventoryAWSList",
  // },
  {
    path: "/technology/gcp/:service",
    element: ApplicationData,
    requiredPermission: "inventoryGCPList",
  },
  {
    path: "/technology/azure/:service",
    element: ApplicationData,
    requiredPermission: "inventoryAzureList",
  },

  {
    path: "/inventory/aws",
    element: InventoryAWS,
    requiredPermission: "inventoryAWSList",
  },
  {
    path: "/inventory/gcp",
    element: InventoryGCP,
    requiredPermission: "inventoryGCPList",
  },
  {
    path: "/inventory/azure",
    element: InventoryAzure,
    requiredPermission: "inventoryAzureList",
  },
  {
    path: "/technology/page",
    element: Technology,
    requiredPermission: "inventoryAzureList",
  },

  // Reviews

  { path: "/scan", element: Scan, requiredPermission: "scanList" },
  {
    path: "/scan/createNewScan",
    element: CreateNewScan,
    requiredPermission: "scanList",
  },
  {
    path: "/scanPolicy",
    element: ScanPolicy,
    requiredPermission: "scanPluginList",
  },
  {
    path: "/scanReport",
    element: ScanReport,
    requiredPermission: "scanReportList",
  },
  {
    path: "/scanReportPage",
    element: ScanReportPage,

    requiredPermission: "scanReportList",
  },
  {
    path: "/peopleManagement/trainings/:id",
    element: ViewTrainings,
    requiredPermission: "trainingList",
  },
  {
    path: "/newIntegration",
    element: CreateNewIntegration,
    requiredPermission: "integrationList",
  },
  { path: "/audit", element: Audit, requiredPermission: "auditList" },
  { path: "/evidence", element: Evidence, requiredPermission: "evidenceList" },
  {
    path: "/evidenceById/:Collection",
    element: EvidencePageCollection,
    requiredPermission: "evidenceList",
  },
  {
    path: "/audit-evidence",
    element: AuditEvidence,
    requiredPermission: "auditList",
  },
  {
    path: "/policyManagement",
    element: PolicyManagement,
    requiredPermission: "policyList",
  },
  {
    path: "/peopleManagement",
    element: PeopleManagement,
    requiredPermission: "peopleList",
  },
  {
    path: "/riskmanagement",
    element: RiskManagement,
    requiredPermission: "riskList",
  },
  {
    path: "/listOfNonCompliances",
    element: ListOfNonCompliances,
    requiredPermission: "exceptionList",
  },
  {
    path: "/vendorManagement",
    element: VendorManagement,
    requiredPermission: "vendorList",
  },
  {
    path: "/vendors/response/:id",
    element: Response,
    requiredPermission: "vendorList",
  },
  {
    path: "/vendors/getVendorPage/:token",
    element: VendorSendPage,
    requiredPermission: "vendorList",
  },
  {
    path: "/organizationInfo",
    element: OrganizationInfo,
    requiredPermission: "organizationAdd",
  },
  {
    path: "/userManagement",
    element: UserManagement,
    requiredPermission: "userList",
  },
  {
    path: "/roleManagement",
    element: RolesPage,
    requiredPermission: "roleList",
  },
  {
    path: "/trainingManagement",
    element: TrainingManagement,
    requiredPermission: "trainingList",
  },
  {
    path: "/serviceRequests",
    element: ServiceRequests,
    requiredPermission: "serviceList",
  },
  // {
  //   path: "/listOfException",
  //   element: ListOfException,
  //   requiredPermission: "exceptionApprovalList",
  // },
  {
    path: "/expceptionApprovals",
    element: ListOfException,
    requiredPermission: "exceptionApprovalList",
  },
  {
    path: "/vendorReview",
    element: VendorReview,
    requiredPermission: "vendorReviewList",
  },
  // {
  //   path: "/vendorReview/responseReview",
  //   element: ResponseReview,
  //   requiredPermission: "vendorReviewList",
  // },
  {
    path: "/policyApproval",
    element: ResponseReview,
    requiredPermission: "vendorReviewList",
  },
  {
    path: "/create-new",
    element: CreateNew,
    requiredPermission: "createNewList",
  },
];
